var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`custom-form agreen-checkbox ${_vm.error?'error':''}`},[_c('van-checkbox',{attrs:{"checked-color":_vm.model.color,"shape":"square"},on:{"change":function($event){_vm.error = false}},model:{value:(_vm.inputValue),callback:function ($$v) {_vm.inputValue=$$v},expression:"inputValue"}},[_vm._v(" "+_vm._s(_vm.model.label)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }